import { render, staticRenderFns } from "./LoginLogoutBtn.vue?vue&type=template&id=951d05d2"
import script from "./LoginLogoutBtn.vue?vue&type=script&lang=js"
export * from "./LoginLogoutBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports